import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
//components
import Input from "../../../../../../../components/input/Input";
import FileInput from "../../../../../../../components/input/FileInput";
import TextareaInput from "../../../../../../../components/input/TextareaInput";
//services
import { getOccurences } from "../../../../../../../services/Contracts/getOccurences";
import { postOccurence } from "../../../../../../../services/Contracts/postOccurence";
//modals
import ModalEdit from "./ModalEdit";
//utils
import { formatDate } from "../../../../../../../utils/formatDate";
import { useAppContext } from "../../../../../../../context/AppContext";

const Occurrence = ({ setActiveIndex, id }) => {

  const { permissions } = useAppContext();
  const defaultValues = {
    description: "",
  };
  const [tableData, setTableData] = useState();
  const [showModal, setShowModal] = useState(false);
  const [defaultValuesModal, setDefaultValuesModal] = useState();

  const form = useForm({ defaultValues });
  const errors = form.formState.errors;

  // const formFile = useForm();
  // const errorsFile = formFile.formState.errors;

  const {
    data: dataOccurrences,
    isLoading: isLoadingOccurences,
    refetch,
  } = useQuery(
    `occurences${id}`, 
    () => getOccurences(id),
    { enabled: !!permissions?.includes("57")}
  );

  const columnsCancel = [
    { field: "occurrence_date", header: "Data Ocorrencia" },
    { field: "title", header: "Título" },
    { field: "description", header: "Descrição" },
    {
      field: "status",
      header: "Status",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            labelClass = "badge bg-warning";
            labelText = "Em Andamento";
            break;
          case 1:
            labelClass = "badge bg-success";
            labelText = "Finalizada";
            break;
          case 2:
            labelClass = "badge bg-success";
            labelText = "Finalizada Pelo Atendente";
            break;
          default:
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "10px",
              marginLeft: "15px",
              marginRight: "-40px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
    {
      field: "annex",
      header: "Anexo",
      body: (rowData) => {
        let annexLabelClass = "fa-solid fa-file";
        return (
          <div className="text-center">
            {rowData.fileLink && (
              <button
                className="btn btn-info btn-btn-sm"
                onClick={() => window.open(rowData.fileLink, "_blank")}
              >
                <i className={annexLabelClass}></i>
              </button>
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    if (dataOccurrences) {
      const formated = dataOccurrences.map((item) => {
        if (item && item.occurrence_date !== null) {
          const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!datePattern.test(item.occurrence_date)) {
            item.occurrence_date = formatDate(item.occurrence_date);
          }
        }
        return item;
      });
      setTableData(formated);
    }
  }, [dataOccurrences]);

  const onSubmit = async (data) => {
    if (document !== "") {
      data.file = document;
    }
    data.sale_id = id;
    const notification = toast.loading("Por favor aguarde...");
    try {
      await postOccurence(data);
      await refetch();
      setDocument("");
      form.reset();
      toast.update(notification, {
        render: "Ocorrência cadastrada com Sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      toast.update(notification, {
        render: error.message,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      return;
    }
    form.reset();
  };

  const showFile = (e) => {
    e.preventDefault();
    setFileVisible(true);
  };

  const openEdit = (rowData) => {
    setDefaultValuesModal(rowData);
    setShowModal(true);
  };

  const [fileVisible, setFileVisible] = useState(false);
  const [document, setDocument] = useState("");
  return (
    <>
      <div className="row">
        <div className="card-border me-2 my-2">
          <div className="title-container">
            <p>
              {" "}
              <i className="fa-solid fa-file-lines me-2"></i>Ocorrências
            </p>
          </div>
          <div className="row mt-2 p-4">
            <h4 className="text-success">
              <i className="fa-solid fa-circle-plus mx-2"></i>Nova Ocorrência
            </h4>
            <hr />
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <div className="row">
                <div className="row col-md-12">
                    <div className="col-xl-8">
                      <Input
                        disabled={permissions && !permissions.includes("73")} //Cadastrar Ocorrências 
                        name="title"
                        control={form.control}
                        errors={errors}
                        label="Título"
                      />
                    </div>
                    <div className="col-xl-4">
                      <Button
                        disabled={permissions && !permissions.includes("73")} //Cadastrar Ocorrências 
                        rounded
                        iconPos="left"
                        label={document ? "Arquivo Anexado" : "Anexar Arquivo"}
                        onClick={(e) => showFile(e)}
                        icon={
                          document ? "fa-solid fa-check" : "fa-solid fa-plus"
                        }
                        className={`p-inputtext-sm mt-4 w-100 ${document && "bg-green-500"
                          }`}
                        tooltip={document && "Clique Para Alterar o Anexo"}
                        tooltipOptions={{ position: "top" }}
                      />
                    </div>
                  <div className="col-xl-12 mt-4">
                    <TextareaInput
                      disabled={permissions && !permissions.includes("73")} //Cadastrar Ocorrências 
                      name="description"
                      label="Descrição"
                      errors={errors}
                      control={form.control}
                    />
                  </div>
                </div>
              </div>
              {permissions && permissions.includes("73") && ( //Cadastrar Ocorrências 
                <div className="col-md-12 mt-3 text-end">
                  <Button
                    rounded
                    type="submit"
                    iconPos="right"
                    label="Cadastrar"
                    icon="fa-solid fa-circle-chevron-right"
                    className="p-inputtext-sm m-auto"
                  />
                </div>
              )}
            </form>
            <h4 className="text-success">
              {" "}
              <i className="fa-regular fa-file-lines mx-2"></i>Ocorrências
              Cadastradas
            </h4>
            <hr />
            {isLoadingOccurences ? (
              <Skeleton width="100%" height="150px" />
            ) : (
              <DataTable
                rows={5}
                paginator
                stripedRows
                showGridlines
                sortMode="multiple"
                // loading={isLoadingOccurences}
                selectionMode="single"
                rowsPerPageOptions={[5, 25, 100]}
                value={tableData}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                {columnsCancel.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    body={col.body}
                  />
                ))}
                {permissions && permissions.includes("74") && ( //Editar Ocorrências 
                  <Column
                    header="Editar"
                    body={(rowData) => (
                      <div className="text-center">
                        <button
                          className="btn btn-warning btn-btn-sm"
                          onClick={() => openEdit(rowData)}
                        >
                          <i className="fa fa-pen-to-square"></i>
                        </button>
                      </div>
                    )}
                  />
                )}
              </DataTable>
            )}
          </div>
        </div>
      </div>

      <Dialog
        header="Anexar arquivo"
        className=""
        visible={fileVisible}
        position="center"
        style={{ width: "50vw" }}
        onHide={() => setFileVisible(false)}
        draggable={false}
        resizable={false}
      >
        <div className="row">
          <div className="card p-3 bg-cyan-300 rounded-3 bg-opacity-75">
            <span className="text-blue-800">
              <i className="fa-solid fa-circle-info me-1"></i>
              <b>Atenção</b>: Anexe os arquivos no tipo <b>correspondente</b> de
              cada arquivo.
            </span>
          </div>
        </div>
        <FileInput
          name="archive"
          setSelectedFile={setDocument}
          base64={true}
          doc="Arquivo"
          icon="fa-file"
        />
        <div className="d-flex justify-content-end mt-4">
          <Button
            label="Cancelar"
            icon="pi pi-times"
            onClick={() => setFileVisible(false)}
            className="p-button-text"
          />
          <Button
            label="Criar"
            icon="pi pi-check"
            onClick={() => setFileVisible(false)}
            autoFocus
          />
        </div>
      </Dialog>
      <ModalEdit
        id={id}
        showModal={showModal}
        setShowModal={setShowModal}
        defaultValuesModal={defaultValuesModal}
      />
    </>
  );
};

export default Occurrence;
